import {createProxy} from '../factory';

interface ProxySettings {
  factory: ServiceFactory;
  handler: ErrorHandler;
  methods: string[];
  async?: boolean;
}

export function withProxy({factory, ...rest}: ProxySettings): () => void {
  return function applyProxy() {
    const service = factory();
    return createProxy({service, ...rest});
  };
}
